module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik0wIDBoMTh2MThIMHoiLz4KICAgICAgICA8cGF0aCBkPSJNMTUuOCA4Ljg1Yy0xLjczNCAzLjUtMy45IDUuMjUtNi41IDUuMjVzLTQuNzY2LTEuNzUtNi41LTUuMjVDNC41MzQgNS4zNSA2LjcgMy42IDkuMyAzLjZzNC43NjYgMS43NSA2LjUgNS4yNSIgZmlsbD0iI0VDRUNFQyIvPgogICAgICAgIDxjaXJjbGUgZmlsbD0iI0JFQkRCRCIgY3g9IjkuNDUiIGN5PSI4LjU1IiByPSIyLjI1Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/views.svg
// module id = yJsa
// module chunks = 30